import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { NAGAR_PANCHAYAT_CONFIG_URL } from "../../../../api/api_routing_urls";
import useAuth from "../../../../authentication/hooks/useAuth";
import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import Dashboard from "../../../../common/Dashboard";
import MasterConfigHeaderWithoutDeleteWrapper from "../../../../common/master-config/MasterConfigHeaderWithoutDeleteWrapper";
import GenericModal from "../../../../reusable-components/modals/GenericModal";
import showToast from "../../../../utilities/notification/NotificationModal";
import AddNagarPanchayatForm from "./AddNagarPanchayatForm";
import NagarPanchayatList from "./NagarPanchayatList";

const NagarPanchayatConfig = () => {
  const { auth } = useAuth();

  const [nagarPanchayatList, setNagarPanchayatList] = useState([]);
  const axiosPrivate = useAxiosPrivate();
  const [showAddForm, setShowAddForm] = useState(false);
  const [editNagarPanchayatDetails, setEditNagarPanchayatDetails] = useState(
    {}
  );
  const isEdit =
    Object.keys(editNagarPanchayatDetails).length > 0 ? true : false;
  const controller = new AbortController();
  const getNagarPanchayatList = async () => {
    try {
      const response = await axiosPrivate.get(NAGAR_PANCHAYAT_CONFIG_URL, {
        signal: controller.signal,
      });
      response.status === 200 &&
        setNagarPanchayatList(response.data.nagarPanchayatList);
      response.status === 202 &&
        showToast("No state list found in the system", "error");
    } catch (error) {
      console.error(error);
      if (!error?.response) {
        showToast("No Server Response");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error"
        );
      }
    }
  };
  useEffect(() => {
    let isMounted = true;
    getNagarPanchayatList();
    setEditNagarPanchayatDetails({});
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);
  return (
    <Dashboard sidebarType={auth.rolename}>
      <ToastContainer />
      <MasterConfigHeaderWithoutDeleteWrapper
        headerTitle={"Nagar Panchayat"}
        setShowAddForm={setShowAddForm}
      />
      <GenericModal
        open={showAddForm}
        setOpen={setShowAddForm}
        title={` ${isEdit ? "Update Nagar Panchayat" : "Add Nagar Panchayat"}`}
        isAdd={true}
      >
        <AddNagarPanchayatForm
          getNagarPanchayatList={getNagarPanchayatList}
          editNagarPanchayatDetails={editNagarPanchayatDetails}
          setEditNagarPanchayatDetails={setEditNagarPanchayatDetails}
          setShowAddForm={setShowAddForm}
        />
      </GenericModal>
      <div className="grid grid-cols-1">
        <NagarPanchayatList
          nagarPanchayatList={nagarPanchayatList}
          setEditNagarPanchayatDetails={setEditNagarPanchayatDetails}
          setShowAddForm={setShowAddForm}
        />
      </div>
    </Dashboard>
  );
};

export default NagarPanchayatConfig;
